import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCircle = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.3333 10.6667C17.3333 6.98477 14.3486 4 10.6667 4C6.98477 4 4 6.98477 4 10.6667C4 14.3486 6.98477 17.3333 10.6667 17.3333C14.3486 17.3333 17.3333 14.3486 17.3333 10.6667ZM21.3333 10.6667C21.3333 16.5577 16.5577 21.3333 10.6667 21.3333C4.77563 21.3333 0 16.5577 0 10.6667C0 4.77563 4.77563 0 10.6667 0C16.5577 0 21.3333 4.77563 21.3333 10.6667Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgCircle);
export default ForwardRef;
